import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-total-contracts',
  templateUrl: './total-contracts.component.html',
  styleUrls: ['./total-contracts.component.scss']
})
export class TotalContractsComponent {
  @Input() data;
  @Input() tooltip;
  public show: boolean = false

  toggle() {
    this.show = !this.show
  }
}
